import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import webinarcard from "../../img/webinar/webinar-image.webp";
import { Modal } from "react-bootstrap";

import "./HomeWebinar.css";
import { Col, Container, Row } from "react-bootstrap";
import Webinarform from "../../webinarpage/webinarform";
import { useState } from "react";
const HomeWebinar = () => {
  const [showForm, setShowForm] = useState(false);
  const showModal = (items) => {
    setShowForm(true);
  };
  const closeModal = () => {
    setShowForm(false);
  };
  return (
    <>
      <section className=" spacing mb-4 mobile-spacing mt-lg-3 webinar-section">
        <div className="container-fluid py-lg-4 book-section">
          <div className="row py-4">
            <div className="col-lg-6">
              <img
                src={webinarcard}
                alt="Webinar"
                className="img-fluid book-image mb-lg-0 mb-3"></img>
            </div>

            <div className="col-lg-6 main-heading">
              <h2>Webinar</h2>
              <p>Expand Your Knowledge with Our Astrology Books</p>

              <p>
                Join us for a powerful astrology webinar where you'll discover
                the hidden potential of your birth chart and learn how to align
                your planets for success in career, wealth, and relationships.
                Unlock the secret of activating your Raj Yoga, and gain
                practical remedies to navigate life's challenges across all
                dashas. Whether you're seeking personal clarity or aiming to
                become a professional astrologer, this session will guide you
                toward real transformation. Learn from top experts in the field,
                explore how to build your name and career in astrology, and take
                the first step toward helping others while empowering yourself.
              </p>
              <div className="d-flex align-items-left justify-content-left read-more mt-3 gap-3">
                <Link to="" onClick={showModal}>
                  Register Now
                </Link>
                <Link to="">Know More</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        show={showForm}
        onHide={closeModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // dialogClassName="modal-90w"
        size="lg"
        className="appointment-form-modal p-0">
        <Modal.Header closeButton className="pb-0"></Modal.Header>
        <Modal.Body>
          <Webinarform />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HomeWebinar;
